import React from 'react';

import { IconSize, SvgIcon } from './SvgIcon';

interface IconProps {
  size?: IconSize;
}

const PaymentIdeal = (props: IconProps): JSX.Element => (
  <SvgIcon size={props.size}>
    <path
      d="M8.15012 13.1001H5.12012V18.2601H8.15012V13.1001Z"
      fill="#494949"
    />
    <path d="M8.15012 13.1001V18.2501H5.12012" fill="black" />
    <path
      d="M6.64043 12.4298C7.57931 12.4298 8.34043 11.6687 8.34043 10.7298C8.34043 9.7909 7.57931 9.02979 6.64043 9.02979C5.70155 9.02979 4.94043 9.7909 4.94043 10.7298C4.94043 11.6687 5.70155 12.4298 6.64043 12.4298Z"
      fill="#494949"
    />
    <path
      d="M7.82039 9.52002C7.97929 9.67892 8.10534 9.86756 8.19133 10.0752C8.27733 10.2828 8.32159 10.5053 8.32159 10.73C8.32159 10.9547 8.27733 11.1773 8.19133 11.3849C8.10534 11.5925 7.97929 11.7811 7.82039 11.94C7.66149 12.0989 7.47285 12.225 7.26524 12.311C7.05763 12.397 6.83511 12.4412 6.61039 12.4412C6.38567 12.4412 6.16316 12.397 5.95554 12.311C5.74793 12.225 5.55929 12.0989 5.40039 11.94"
      fill="black"
    />
    <path
      d="M13.92 4.00009H3V20.3801H13.92C15.9052 20.4286 17.8492 19.8088 19.44 18.6201C21.04 17.2501 21.83 15.0701 21.83 12.1601C21.8473 10.8951 21.6198 9.63868 21.16 8.46009C20.7953 7.47793 20.2063 6.59448 19.44 5.88009C17.8691 4.64069 15.9208 3.97716 13.92 4.00009ZM13.61 5.21009C15.4352 5.10815 17.2358 5.66928 18.68 6.79009C19.3982 7.47779 19.9554 8.3159 20.3116 9.24432C20.6677 10.1727 20.814 11.1685 20.74 12.1601C20.74 16.9501 18.37 19.1601 13.61 19.1601H4.21V5.21009H13.61Z"
      fill="black"
    />
    <path
      d="M15.5195 11H16.0695C15.9536 10.7601 15.8631 10.5088 15.7995 10.25C15.72 10.5049 15.6265 10.7553 15.5195 11Z"
      fill="#CC1B69"
    />
    <path
      d="M10.1598 11.7901C10.2334 11.7567 10.3037 11.7165 10.3698 11.6701C10.4274 11.6002 10.4685 11.5181 10.4898 11.4301C10.5307 11.2598 10.5508 11.0852 10.5498 10.9101C10.5506 10.7482 10.5304 10.5868 10.4898 10.4301C10.4581 10.3401 10.4069 10.2581 10.3398 10.1901C10.2798 10.1301 10.1898 10.1301 10.0998 10.1001H9.33984V11.9101H9.78984C9.99984 11.8801 10.0998 11.7901 10.1598 11.7901Z"
      fill="#CC1B69"
    />
    <path
      d="M17.5601 12.49V9.48996H18.4701V11.61H19.7101C19.4401 7.36996 16.1901 6.45996 13.1601 6.45996H9.37012V9.45996H9.88012C10.072 9.42693 10.2682 9.42693 10.4601 9.45996C10.6343 9.5015 10.7915 9.59579 10.9101 9.72996C11.0493 9.86765 11.1553 10.0352 11.2201 10.22C11.2856 10.4439 11.3159 10.6767 11.3101 10.91C11.315 11.1268 11.2846 11.3429 11.2201 11.55C11.1583 11.7605 11.0409 11.9505 10.8801 12.1C10.7584 12.2233 10.6163 12.3248 10.4601 12.4C10.2841 12.4682 10.0986 12.5087 9.91012 12.52H9.37012V18.28H13.1601C16.3401 18.28 19.7101 17.37 19.7401 12.52H17.5601V12.49ZM14.2201 12.49H11.7901V9.48996H13.9201V10.09H12.4001V10.4H13.9201V11.31H12.4001V11.91H14.2201V12.49ZM16.5501 12.49C16.4832 12.2817 16.403 12.078 16.3101 11.88H15.3101C15.2172 12.078 15.1371 12.2817 15.0701 12.49H14.2801L15.4601 9.48996H16.1901L17.4001 12.49H16.5501Z"
      fill="#F42588"
    />
    <path
      d="M9.37012 9.46002H9.88012C10.072 9.42699 10.2682 9.42699 10.4601 9.46002C10.6343 9.50156 10.7915 9.59585 10.9101 9.73002C11.0493 9.86771 11.1553 10.0353 11.2201 10.22C11.2856 10.444 11.3159 10.6768 11.3101 10.91C11.315 11.1268 11.2846 11.343 11.2201 11.55C11.1583 11.7606 11.0409 11.9506 10.8801 12.1C10.7584 12.2234 10.6163 12.3249 10.4601 12.4C10.2841 12.4683 10.0986 12.5088 9.91012 12.52H9.37012V18.28H13.1601C16.3401 18.28 19.7101 17.37 19.7401 12.52H17.5601V9.46002H18.4701V11.58H19.7101C19.4401 7.34002 16.1301 6.52002 13.1001 6.52002L9.37012 9.46002ZM13.9201 12.52H11.7901V9.52002H13.9201V10.12H12.4001V10.73H13.9201V11.34H12.4001V11.94H13.9201V12.52ZM16.5501 12.52C16.4832 12.3118 16.403 12.108 16.3101 11.91H15.3101C15.2172 12.108 15.1371 12.3118 15.0701 12.52H14.2801L15.4601 9.52002H16.1901L17.4001 12.52H16.5501Z"
      fill="#CC1B69"
    />
    <path
      d="M18.4703 9.4601V11.5801H19.7103C19.7024 10.6148 19.4291 9.67037 18.9203 8.8501L18.2803 9.4601H18.4703Z"
      fill="#B50662"
    />
    <path
      d="M17.5601 10L16.7101 10.94L17.3401 12.46H16.5501C16.4832 12.2518 16.403 12.048 16.3101 11.85H16.0001L9.37012 18.19V18.25H13.1601C16.3401 18.25 19.7101 17.34 19.7401 12.49H17.5601V10Z"
      fill="#B50662"
    />
    <path
      d="M3 4V20.38L4.21 19.16V5.21H13.61C14.9346 5.20001 16.2464 5.46919 17.46 6L18.34 5.15C16.983 4.41067 15.4653 4.01578 13.92 4H3Z"
      fill="#494949"
    />
  </SvgIcon>
);

export default PaymentIdeal;
